<ng-container *ngIf="calendarData">
  <div class="device-calendar device-calendar__container">

    <div class="modal-header">
      <h1 class="title">{{title}}</h1>
      <div class="modal-header__close-link" [mat-dialog-close]>
        <span class="close" [mat-dialog-close]></span>
      </div>
    </div>
    <div class="device-calendar__wrapper">

      <div class="device-calendar__sidebar">
        <div class="device-calendar__dates">
          <span>{{calendarData.campaignStart}}</span>
          <span>{{calendarData.campaignFinish}}</span>
        </div>
        <div class="device-calendar__name" *ngFor="let device of calendarData.devices | paginate : {id: 'devices',
         itemsPerPage: devicesPerPage, currentPage: currentPage, totalItems: totalDevices}">
          {{device.locationName}}
        </div>
      </div>

      <div class="device-calendar__content">
        <div class="device-calendar__date-title">
          {{calendarData.monthLabel.month + ' ' + calendarData.monthLabel.year}}
        </div>
        <button class="device-calendar__controls device-calendar__controls--next" type="button"
                [disabled]="calendarData.isNextDisabled" (click)="next()">&#8250;
        </button>
        <button class="device-calendar__controls device-calendar__controls--prev" type="button"
                [disabled]="calendarData.isPrevDisabled" (click)="back()">&#8249;
        </button>
        <div class="device-calendar__main" #mainWrapper>
        <span class="device-calendar__overlay-activity" *ngIf="activityCoordinates.visible"
              [ngStyle]="{left: activityCoordinates.startPoint + 'px', right: activityCoordinates.endPoint + 'px'}">&nbsp;</span>
          <div class="header-overlay">
            <div class="device-calendar__header">
              <ul class="device-calendar__days">
                <li class="device-calendar__day"
                    *ngFor="let day of calendarData.calendarHeader"
                    #headerDays
                    [class.current-day]="moment(day.date).isSame(currentDate)"
                    [ngClass]="{'in-activity': day.isActivityPeriod}"
                >{{day.dayNumber}}</li>
              </ul>
            </div>
          </div>
          <div *ngFor="let day of calendarData.devices | paginate : {id: 'devices',
         itemsPerPage: devicesPerPage, currentPage: currentPage, totalItems: totalDevices}">
            <ul class="device-calendar__timeline">
              <li *ngFor="let dayData of day.activity"
                  class="device-calendar__timeline-day device-calendar__timeline-day--{{dayData.days.status}}"></li>
            </ul>
          </div>
        </div>
        <div class="marketplace-page__pagination">
          <pagination-controls class="app-pagination"
                               id="devices"
                               (pageChange)="pageChangeEvent($event)"
                               [directionLinks]="true"
                               [autoHide]="true"
                               [responsive]="true"
                               previousLabel=""
                               nextLabel=""
                               screenReaderPaginationLabel="Pagination"
                               screenReaderPageLabel="page"
                               screenReaderCurrentLabel="You're on page">
          </pagination-controls>
        </div>
      </div>

    </div>
  </div>
</ng-container>
